import { Controller } from "@hotwired/stimulus";

// The help disclosure uses a native <details>/<summary>, so no behavior is
// needed here.
export default class extends Controller {
  connect() {
    // Intentionally left blank.
  }
}
